import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "@/lib/api";

export const LABELS = { instagram: "Instagram", facebook: "Facebook", tiktok: "TikTok", x: "X (Twitter)", linkedin: "LinkedIn", print: "Printed flyer", other: "Other" };

export const MarketingStats = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/marketing/stats").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid="marketing-stats">
      <div className="mb-3 flex items-center justify-between">
        <p className="text-sm font-semibold">Scans & sales by platform</p>
        <button onClick={load} className="flex items-center gap-1 text-xs text-blue-700 hover:underline" data-testid="marketing-stats-refresh"><RefreshCw className="h-3.5 w-3.5" /> Refresh</button>
      </div>
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs uppercase text-slate-500"><th className="py-1">Platform</th><th>Scans/clicks</th><th>Quotes</th><th>Policies sold</th></tr></thead>
        <tbody>
          {(rows || []).map((r) => (
            <tr key={r.source} className="border-t border-slate-100" data-testid={`marketing-stats-row-${r.source}`}>
              <td className="py-1.5">{LABELS[r.source]}</td><td>{r.scans}</td><td>{r.quotes}</td><td className="font-semibold">{r.sold}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-2 text-xs text-slate-500">Counts every scan of a flyer's QR code and every click on a caption link, then the quotes and purchases that followed.</p>
    </div>
  );
};
